<div class="ibox detailed-view-ibox"
     *ngIf="settingsDirectoryService.showDetailedView && settingsDirectoryService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{settingsDirectoryService.chosenCorporation.name}}</div>
        <span class="close-detailed-view" (click)="settingsDirectoryService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div>
                    <div class="detailed-view-navigation">
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('tab_settings')"
                                 [ngStyle]="{'background-color': navPosition == 'tab_settings' ? '#ebebeb' : ''}">
                                General
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('notifications')"
                                 [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                Notifications
                            </div>
                        </div>
                    </div>
                </div>
                <div class="services-list" *ngIf="navPosition == 'tab_settings'">
                    <div class="services-list-item">
                        <mat-slide-toggle name="petFriendly"
                                          (change)="onSubmit({settings: {petFriendly: form.value.petFriendly ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.petFriendly">
                        </mat-slide-toggle>
                        <span>Pet Friendly</span>
                    </div>
                    <hr>
                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="useResidentInstruction"
                                          (change)="onSubmit({settings: {useResidentInstruction: form.value.useResidentInstruction ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.useResidentInstruction">
                        </mat-slide-toggle>
                        <span>Front Desk Instruction for Resident</span>
                    </div>

                    <hr>

                    <!--<div class="services-list-item m-b-sm">
                        <span>Data Confirmation</span>
                    </div>
                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="useDateOfBirth"
                                          (change)="onSubmit({settings: {useDateOfBirth: form.value.useDateOfBirth ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.useDateOfBirth">
                        </mat-slide-toggle>
                        <span>Use Date Of Birth</span>
                    </div>

                    <hr>-->

                    <div class="services-list-item m-b-sm">
                        <span>Waivers</span>
                    </div>

                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="useEmailWaiver"
                                          (change)="onSubmit({settings: {useEmailWaiver: form.value.useEmailWaiver ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.useEmailWaiver">
                        </mat-slide-toggle>
                        <span>Electronic Notifications Agreement</span>
                    </div>

                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="useParcelsWaiver"
                                          (change)="onSubmit({settings: {useParcelsWaiver: form.value.useParcelsWaiver ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.useParcelsWaiver">
                        </mat-slide-toggle>
                        <span>Parcels</span>
                    </div>

                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="useKeyWaiver"
                                          (change)="onSubmit({settings: {useKeyWaiver: form.value.useKeyWaiver ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.useKeyWaiver">
                        </mat-slide-toggle>
                        <span>Keys</span>
                    </div>

                    <hr>

                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="autoInviteResidents"
                                          (change)="onSubmit({settings: {autoInviteResidents: form.value.autoInviteResidents ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.autoInviteResidents">
                        </mat-slide-toggle>
                        <span>Resident Auto Invite</span>
                    </div>

                    <div class="services-list-item m-b-sm">
                        <mat-slide-toggle name="autoApproveResidentDataChanges"
                                          (change)="onSubmit({settings: {autoApproveResidentDataChanges: form.value.autoApproveResidentDataChanges ? 1 : 0}})"
                                          [ngModel]="settingsDirectoryService.selectedItemData.settings.autoApproveResidentDataChanges">
                        </mat-slide-toggle>
                        <span>Auto Approve Resident Data Changes</span>
                    </div>

                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="residentsEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Residents</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="unitsEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Units</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="parkingSpotsEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Parking Spots</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="lockersEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Lockers</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="vehiclesEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Vehicles</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="petsEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Pets</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="bikeRacksEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Bike Racks</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="visitorsEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Visitors</span>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <!--<div class="services-list-item">-->
                        <!--<mat-slide-toggle name="staffEnabled"-->
                                          <!--(change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"-->
                                          <!--[ngModel]="settingsDirectoryService.selectedItemData.allowResidentsToBook">-->
                        <!--</mat-slide-toggle>-->
                        <!--<span>Staff</span>-->
                    <!--</div>-->
                </div>
                <div *ngIf="navPosition == 'notifications'">
                    <div class="settings-amenities-slider-container">
                        <span>Notify Staff</span>
                    </div>
                    <div style="position: relative;">
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsDirectoryService.updatedByStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'updated_by_staff')"
                                       name="updatedByStaffCheckbox"
                                       id="updatedByStaffCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="updatedByStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'updated_by_staff') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'updated_by_staff')">
                            Data is changed by staff
                        </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsDirectoryService.updatedByStaffCheckbox">
                            <multiselect-field name="updatedByStaffMultiselectArray"
                                               [data]="settingsDirectoryService.userRoles"
                                               [(ngModel)]="settingsDirectoryService.updatedByStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>

                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsDirectoryService.updatedByResidentCheckbox"
                                       name="updatedByResidentCheckbox"
                                       id="updatedByResidentCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="updatedByResidentCheckbox">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color">Request for data changes by resident</span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsDirectoryService.updatedByResidentCheckbox">
                            <multiselect-field name="updatedByResidentMultiselectArray"
                                               [data]="settingsDirectoryService.userRoles"
                                               [(ngModel)]="settingsDirectoryService.updatedByResidentMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                    </div>

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                   <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="bookingDeclinedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text"-->
                              <!--(click)="showNotificationModal('staff', 'declined')">User Declined</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsDirectoryService.bookingDeclinedStaffCheckbox">-->
                        <!--<multiselect-field-->
                            <!--name="bookingDeclinedStaffMultiselect"-->
                            <!--[data]="settingsDirectoryService.userRoles"-->
                            <!--[(ngModel)]="settingsDirectoryService.declinedStaffMultiselectArray"-->
                            <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                   <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="bookingDeclinedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span style="font-weight: normal"-->
                              <!--(click)="showNotificationModal('staff', 'declined')">Information Update By Staff</span>-->
                        <!--<i class="fa {{expandInformationUpdateByStaff ? 'fa-chevron-up' : 'fa-chevron-down'}} m-l-sm"-->
                           <!--(click)="expandInformationUpdateByStaff = !expandInformationUpdateByStaff"></i>-->
                    <!--</div>-->
                    <!--<div class="information-update-children-wrapper" *ngIf="expandInformationUpdateByStaff">-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Staff</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Resident</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Unit</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Vehicle</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Locker</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Pets</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Bikes</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Visitors</span>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                   <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="bookingDeclinedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span style="font-weight: normal"-->
                              <!--(click)="showNotificationModal('staff', 'declined')">Information Update By Resident</span>-->
                        <!--<i class="fa {{expandInformationUpdateByResident ? 'fa-chevron-up' : 'fa-chevron-down'}} m-l-sm"-->
                           <!--(click)="expandInformationUpdateByResident = !expandInformationUpdateByResident"></i>-->
                    <!--</div>-->
                    <!--<div class="information-update-children-wrapper" *ngIf="expandInformationUpdateByResident">-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Staff</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Resident</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Unit</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Vehicle</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Locker</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Pets</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Bikes</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsDirectoryService.bookingDeclinedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'declined')"-->
                                       <!--name="bookingDeclinedStaffCheckbox" id="bookingDeclinedStaffCheckbox"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="bookingDeclinedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'declined')">Visitors</span>-->
                        <!--</div>-->
                    <!--</div>-->

                    <hr>

                    <div class="settings-amenities-slider-container">
                        <span>Notify Residents</span>
                    </div>

                    <div style="position: relative;">
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsDirectoryService.updatedApprovedCheckbox"
                                       name="updatedApprovedCheckbox"
                                       id="updatedApprovedCheckbox"
                                       (change)="submitResidentsNotificationSettings()">
                                <label for="updatedApprovedCheckbox">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'profile_changes_approved')">
                            Request is Approved
                        </span>
                        </div>
                    </div>

                    <div style="position: relative;">
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsDirectoryService.updatedDeclinedCheckbox"
                                       name="updatedDeclinedCheckbox"
                                       id="updatedDeclinedCheckbox"
                                       (change)="submitResidentsNotificationSettings()">
                                <label for="updatedDeclinedCheckbox">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'profile_changes_declined')">
                            Request is Declined
                        </span>
                        </div>
                    </div>

                    <hr>

                    <div class="settings-amenities-slider-container">
                        <span>Reminders</span>
                    </div>
                    <div class="m-b-sm reminder-row"
                         *ngFor="let reminder of settingsDirectoryService.selectedItemData.reminders; let index = index;">
                        <div class="clickable">
                            <label class="img-checkbox no-decoration">
                                <input id="reminderEnableStatus{{index}}"
                                       type="checkbox"
                                       [checked]="reminder.enableStatus"
                                       (click)="changeReminderStatus($event, index)">
                                <label for="reminderEnableStatus{{index}}"><svg-checked></svg-checked></label>
                            </label>
                            <span class="mtv-primary-color" (click)="editReminder(index)">{{reminder.title}}</span>
                        </div>
                        <!--<i *ngIf="settingsDirectoryService.selectedItemData.isCanDelete"-->
                        <i
                           class="fa fa-trash pull-right"
                           (click)="deleteReminder(index)">
                        </i>
                    </div>
                    <i class="icon-plus pull-right"
                       (click)="settingsDirectoryService.isRemindersModalShow = true;">
                       <!--*ngIf="settingsDirectoryService.selectedItemData.isCanEdit">-->
                    </i>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/settings-directory-detailed-view/settings-directory-detailed-view.component.html